// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const ManageQuestions = () => {
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [studentName, setStudentName] = useState("");
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const navigate = useNavigate();

//   const fetchQuestions = async () => {
//     setLoading(true);
//     try {
//       const query = new URLSearchParams({
//         page,
//         limit,
//         ...(studentName && { studentName }),
//       }).toString();

//       const response = await fetch(
//         `http://localhost:5001/api/questions/all?${query}`
//       );
//       const result = await response.json();

//       setQuestions(result.data || []);
//       setTotalPages(result.totalPages || 1);
//     } catch (err) {
//       console.error("Error fetching questions:", err);
//       setQuestions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Automatically fetch when page or studentName changes
//   useEffect(() => {
//     fetchQuestions();
//   }, [page, studentName, limit]);

//   const handleSearch = () => {
//     setPage(1); // ✅ Reset to first page
//   };

//   const handleClear = () => {
//     setStudentName("");
//     setPage(1); // ✅ Reset to first page
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setPage(newPage);
//     }
//   };

//   return (
//     <>
//       <header>
//         <div className="homebanner">
//           <img src="homebanner.png" alt="HomePage Banner" />
//         </div>
//         <div className="homelogo">
//           <img src="church_logo_no_bg.png" alt="Church Logo" />
//         </div>
//         <div className="cross_icon">
//           <img src="cross_icon.png" alt="Cross Icon" />
//         </div>
//       </header>

//       <footer>
//         <div className="homebody">
//           {/* ✅ Back Button */}
//           <button
//             onClick={() => navigate("/HomePage")}
//             className="mb-4 text-blue-600 hover:underline"
//           >
//             ← Back to Dashboard
//           </button>
//           <div className="managebody">
//             <h1>Manage Questions</h1>
//           </div>

//           <form
//             className="filter-section"
//             onSubmit={(e) => {
//               e.preventDefault();
//               handleSearch();
//             }}
//           >
//             <input
//               type="text"
//               placeholder="Search by student name"
//               value={studentName}
//               onChange={(e) => setStudentName(e.target.value)}
//             />
//             <button type="submit">Search</button>
//             <button
//               type="button"
//               onClick={handleClear}
//               style={{ marginLeft: "0.5rem" }}
//               className="bg-gray-300 px-3 py-1 rounded"
//             >
//               Clear
//             </button>
//           </form>

//           <div className="table-wrapper">
//             {loading ? (
//               <p>Loading questions...</p>
//             ) : questions.length === 0 ? (
//               <p>No questions found.</p>
//             ) : (
//               <table className="student-table">
//                 <thead>
//                   <tr>
//                     <th>Student Name</th>
//                     <th>Student Email</th>
//                     <th>Question</th>
//                     <th>Time and Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {questions.map((q, index) => (
//                     <tr key={index}>
//                       <td>{q.name}</td>
//                       <td>{q.email}</td>
//                       <td>{q.question}</td>
//                       <td>{new Date(q.timestamp).toLocaleString()}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>

//           <div className="pagination">
//             <button
//               className="pagination_bracket"
//               onClick={() => handlePageChange(page - 1)}
//               disabled={page === 1}
//             >
//               &lt;
//             </button>
//             {Array.from({ length: totalPages }, (_, i) => (
//               <button
//                 key={i + 1}
//                 className={page === i + 1 ? "active" : ""}
//                 onClick={() => handlePageChange(i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}
//             <button
//               className="pagination_bracket"
//               onClick={() => handlePageChange(page + 1)}
//               disabled={page === totalPages}
//             >
//               &gt;
//             </button>
//           </div>
//           {/* ✅ Rows per page selector */}
//           <div className="ml-4 mt-4">
//             <label htmlFor="limit" className="mr-2 font-medium text-sm">
//               Rows per page:
//             </label>
//             <select
//               id="limit"
//               value={limit}
//               onChange={(e) => {
//                 setLimit(parseInt(e.target.value));
//                 setPage(1);
//               }}
//               className="border rounded px-2 py-1"
//             >
//               <option value={10}>10</option>
//               <option value={20}>20</option>
//               <option value={50}>50</option>
//             </select>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default ManageQuestions;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ManageQuestions = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [studentName, setStudentName] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [modalContent, setModalContent] = useState(null);
  const navigate = useNavigate();

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        limit,
        ...(studentName && { studentName }),
      }).toString();

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/questions/all?${query}`
      );
      const result = await response.json();

      setQuestions(result.data || []);
      setTotalPages(result.totalPages || 1);
    } catch (err) {
      console.error("Error fetching questions:", err);
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchQuestions();
  }, [page, studentName, limit]);

  const handleSearch = () => {
    setPage(1);
  };

  const handleClear = () => {
    setStudentName("");
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const openModal = (question) => {
    setModalContent(question);
  };

  const closeModal = () => {
    setModalContent(null);
  };

  return (
    <>
      <header>
        <div className="homebanner">
          <img src="homebanner.png" alt="HomePage Banner" />
        </div>
        <div className="homelogo">
          <img src="church_logo_no_bg.png" alt="Church Logo" />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Cross Icon" />
        </div>
      </header>

      <footer>
        <div className="homebody">
          <button
            onClick={() => navigate("/HomePage")}
            className="mb-4 text-blue-600 hover:underline"
          >
            ← Back to Dashboard
          </button>
          <div className="managebody">
            <h1>Manage Questions</h1>
          </div>

          <form
            className="filter-section"
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            <input
              type="text"
              placeholder="Search by student name"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
            />
            <button type="submit">Search</button>
            <button
              type="button"
              onClick={handleClear}
              style={{ marginLeft: "0.5rem" }}
              className="bg-gray-300 px-3 py-1 rounded"
            >
              Clear
            </button>
          </form>

          <div className="table-wrapper">
            {loading ? (
              <p>Loading questions...</p>
            ) : questions.length === 0 ? (
              <p>No questions found.</p>
            ) : (
              <table className="student-table">
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Student Email</th>
                    <th>Question</th>
                    <th>Time and Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.map((q, index) => (
                    <tr key={index}>
                      <td>{q.name}</td>
                      <td>{q.email}</td>
                      <td
                        style={{
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {q.question}
                      </td>
                      <td>{new Date(q.timestamp).toLocaleString()}</td>
                      <td>
                        <button onClick={() => openModal(q)}>View</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="pagination">
            <button
              className="pagination_bracket"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              &lt;
            </button>
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={page === i + 1 ? "active" : ""}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              className="pagination_bracket"
              onClick={() => handlePageChange(page + 1)}
              disabled={page === totalPages}
            >
              &gt;
            </button>
          </div>

          <div className="ml-4 mt-4">
            <label htmlFor="limit" className="mr-2 font-medium text-sm">
              Rows per page:
            </label>
            <select
              id="limit"
              value={limit}
              onChange={(e) => {
                setLimit(parseInt(e.target.value));
                setPage(1);
              }}
              className="border rounded px-2 py-1"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </footer>

      {modalContent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
            <h2 className="text-lg font-semibold mb-4">Student Question</h2>
            <p>
              <strong>Name:</strong> {modalContent.name}
            </p>
            <p>
              <strong>Email:</strong> {modalContent.email}
            </p>
            <p>
              <strong>Question:</strong> {modalContent.question}
            </p>
            <p>
              <strong>Date:</strong>{" "}
              {new Date(modalContent.timestamp).toLocaleString()}
            </p>
            <div className="flex justify-end space-x-4 mt-4">
              <button
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                onClick={() => {
                  window.location.href = `mailto:${modalContent.email}?subject=Reply to your question&body=Hi ${modalContent.name},%0D%0A%0D%0ARegarding your question: "${modalContent.question}"%0D%0A%0D%0AHere's our response:`;
                }}
              >
                Reply
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageQuestions;
